import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

import { getWorkflowLabel } from '../helpers';

const STATE_LABELS: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  live: 'Live',
  ended: 'Ended',
  archived: 'Archived',
};

const getStateLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    return STATE_LABELS[value] ?? value;
  }
  return 'Unknown';
};

const getActionTitle = (
  oldState: unknown,
  newState: unknown,
  workflowLabel: string,
): string => {
  const newStr = typeof newState === 'string' ? newState : '';

  switch (newStr) {
    case 'active':
    case 'live':
      return `Launched ${workflowLabel}`;
    case 'ended':
      return `Ended ${workflowLabel}`;
    case 'archived':
      return 'Archived';
    default:
      return `Changed state from ${getStateLabel(oldState)} to ${getStateLabel(newState)}`;
  }
};

const StateChangeRender = ({ change }: ActivityChangeOptions) => {
  return (
    <ActivityItem.Section label="Updated state">
      <ActivityTagItem
        oldValue={getStateLabel(change.oldValue)}
        newValue={getStateLabel(change.newValue)}
      />
    </ActivityItem.Section>
  );
};

export const STATE_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'state-change',
  priority: 10,
  predicate: ({ change }) => change.fieldPath === '/state',
  title: (change, options) => {
    const workflowLabel = getWorkflowLabel(options?.activity.primaryResource);
    return getActionTitle(change.oldValue, change.newValue, workflowLabel);
  },
  render: StateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
